class Revue {
  constructor () {
    this.slideshowRevues();
  }
  slideshowRevues() {
    $(window).on('load', function(){
      // Adds the two views to one container for display
      $('#block-derniere-revue-des-parents').appendTo(".slideshow-revues");
      $('div[id^=block-views-block-revue-des-parents-nav]').appendTo(".slideshow-revues");

      $('div[id^=block-derniere-revue-des-parents] .view-content').slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        focusOnSelect: true,
        asNavFor: 'div[id^=block-views-block-revue-des-parents-nav] .view-content'
      })
      $('div[id^=block-views-block-revue-des-parents-nav] .view-content').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: true,
        asNavFor: 'div[id^=block-derniere-revue-des-parents] .view-content'
      });
    });
  }
}

export default Revue;